
import React from 'react';
import { FAQSection as CommonFAQSection } from "@/components/common/FAQ";

const FAQSection = () => {
  const faqs = [
    {
      question: "How do I hire an AI staff member?",
      answer: "Go to the Hiring page, select a suitable AI staff candidate for your role, and complete the interview process to add them to your team."
    },
    {
      question: "What integrations are available?",
      answer: "Currently, we support integration with Slack, with more platforms coming soon including email services, social media, and CRM systems."
    },
    {
      question: "Can I customize my AI staff?",
      answer: "Yes, you can train and customize your AI staff over time by providing feedback and uploading relevant business materials through the management interface."
    },
    {
      question: "What's the refund policy?",
      answer: "We offer a 14-day money-back guarantee if you're not satisfied with your AI staff performance. Contact support for details."
    }
  ];

  return (
    <CommonFAQSection 
      faqs={faqs} 
      variant="card" 
    />
  );
};

export default FAQSection;
